export var AccessLevelEnum;
(function (AccessLevelEnum) {
    AccessLevelEnum["NO_ACCESS"] = "NO_ACCESS";
    AccessLevelEnum["LIMITED"] = "LIMITED";
    AccessLevelEnum["FULL"] = "FULL";
})(AccessLevelEnum || (AccessLevelEnum = {}));
